import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthStore } from '@app/core/auth/auth.store';
import { AppIcon } from '@app/shared/controls/app-icon/app-icon';
import { TranslatePipe } from '@ngx-translate/core';

interface AdminNavItem {
  readonly labelKey: string;
  readonly route: string;
  readonly permissionPrefixes: readonly string[];
}

@Component({
  selector: 'app-nav-admin',
  imports: [AppIcon, RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './nav-admin.html',
  styleUrl: './nav-admin.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavAdmin {
  private readonly authStore = inject(AuthStore);

  readonly settingsRequested = output<void>();

  private readonly allSupportItems: readonly AdminNavItem[] = [
    { labelKey: 'settings.navigation.admin.support.tenants', route: '/support/tenants', permissionPrefixes: ['PERM_PLATFORM_TENANT_'] },
    { labelKey: 'settings.navigation.admin.support.communication', route: '/support/communication', permissionPrefixes: ['PERM_PLATFORM_RELEASE_NOTE_'] },
    { labelKey: 'settings.navigation.admin.support.contracts', route: '/support/contracts', permissionPrefixes: ['PERM_PLATFORM_CONTRACT_', 'PERM_PLATFORM_ORDER_'] },
    { labelKey: 'settings.navigation.admin.support.surveys', route: '/support/surveys', permissionPrefixes: ['PERM_PLATFORM_SURVEY_'] },
  ];

  private readonly allSystemItems: readonly AdminNavItem[] = [
    { labelKey: 'settings.navigation.admin.system.scheduledTasks', route: '/system/scheduledtasks', permissionPrefixes: ['PERM_PLATFORM_SCHEDULED_TASK_'] },
    { labelKey: 'settings.navigation.admin.system.integrationStore', route: '/system/integrationstore', permissionPrefixes: ['PERM_PLATFORM_INTEGRATION_'] },
    { labelKey: 'settings.navigation.admin.system.configurations', route: '/system/configurations', permissionPrefixes: ['PERM_PLATFORM_CONFIGURATION_'] },
    { labelKey: 'settings.navigation.admin.system.paymentSettings', route: '/system/paymentsettings', permissionPrefixes: ['PERM_PLATFORM_LICENSE_'] },
  ];

  protected readonly supportItems = computed(() => this.filterItems(this.allSupportItems));
  protected readonly systemItems = computed(() => this.filterItems(this.allSystemItems));

  protected onSettingsRequested(): void {
    this.settingsRequested.emit();
  }

  private filterItems(items: readonly AdminNavItem[]): readonly AdminNavItem[] {
    return items.filter(item => this.authStore.hasAnyPermissionIn(item.permissionPrefixes));
  }
}
